import React, { useEffect, useState } from "react";
import "./SmokeBackground.css";

const SIZE = 256; // текстура маленька — у CSS її розтягують, розмиття = «м'який» дим

// Безшовний фрактальний шум: решітка випадкових значень із загортанням по краях,
// кілька октав з періодами, що ділять розмір текстури — тож плитка стикується без швів.
function makeSmokeTile() {
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = SIZE;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  const octaves = [4, 8, 16, 32].map((cells, i) => ({
    cells,
    weight: 1 / 2 ** i,
    grid: Array.from({ length: cells * cells }, Math.random),
  }));
  const totalWeight = octaves.reduce((s, o) => s + o.weight, 0);
  const smooth = (t) => t * t * (3 - 2 * t);

  const sample = ({ cells, grid }, x, y) => {
    const fx = (x / SIZE) * cells;
    const fy = (y / SIZE) * cells;
    const x0 = Math.floor(fx);
    const y0 = Math.floor(fy);
    const tx = smooth(fx - x0);
    const ty = smooth(fy - y0);
    const at = (gx, gy) => grid[(gy % cells) * cells + (gx % cells)];
    const top = at(x0, y0) + (at(x0 + 1, y0) - at(x0, y0)) * tx;
    const bottom = at(x0, y0 + 1) + (at(x0 + 1, y0 + 1) - at(x0, y0 + 1)) * tx;
    return top + (bottom - top) * ty;
  };

  const image = ctx.createImageData(SIZE, SIZE);
  for (let y = 0; y < SIZE; y++) {
    for (let x = 0; x < SIZE; x++) {
      let n = 0;
      for (const o of octaves) n += sample(o, x, y) * o.weight;
      n /= totalWeight;
      // Лишаємо тільки «хмаринки», решта прозора
      const a = Math.max(0, Math.min(1, (n - 0.42) * 2.4)) ** 1.6;
      const i = (y * SIZE + x) * 4;
      image.data[i] = 214;
      image.data[i + 1] = 218;
      image.data[i + 2] = 255;
      image.data[i + 3] = Math.round(a * 255);
    }
  }
  ctx.putImageData(image, 0, 0);
  return canvas.toDataURL("image/png");
}

/** Легкий дим/пара на фоні всіх екранів. Нічого не перехоплює (pointer-events: none). */
const SmokeBackground = () => {
  const [tile, setTile] = useState(null);

  useEffect(() => {
    setTile(makeSmokeTile());
  }, []);

  return (
    <div className="smoke-bg" aria-hidden="true">
      <div className="smoke-glow" />
      {tile && (
        <>
          <div className="smoke-layer smoke-layer--a" style={{ backgroundImage: `url(${tile})` }} />
          <div className="smoke-layer smoke-layer--b" style={{ backgroundImage: `url(${tile})` }} />
        </>
      )}
    </div>
  );
};

export default SmokeBackground;
